"use strict";

module.exports = a => a === undefined;